import React from 'react';
import { MenuItem, DropdownButton } from 'react-bootstrap';
import seriesIds from 'constants/RateSeriesIds';
import { useTranslation } from 'react-i18next';
const RenderSeriesDropdown = ({ selectedSeriesId, customerType, handleSeriesSelect, }) => {
    const { t } = useTranslation();
    const seriesWithNone = [{ value: null, name: t('NONE') }].concat(seriesIds);
    const series = seriesWithNone.map((s, i) => (React.createElement(MenuItem, { key: i, eventKey: s.value }, `${s.name} ${s.value ? '(' + s.value + ')' : ''}`)));
    return (React.createElement("div", { className: "mb-4" },
        React.createElement("label", { className: "block mb-1 form-label" }, t('SERIES_ID')),
        React.createElement("p", { className: "mt-1 mb-2 text-sm" }, t('REGION_SERIES_ID_FOR_CUSTOMER_TYPE', {
            customerType: customerType,
        })),
        React.createElement(DropdownButton, { title: selectedSeriesId
                ? seriesWithNone.find((s) => s.value === selectedSeriesId).name
                : t('SELECT_SERIES'), onSelect: handleSeriesSelect }, series)));
};
export default RenderSeriesDropdown;
